import { createRouter, createWebHashHistory } from "vue-router";
import { useCookies } from "vue3-cookies";

import baseRoutes from "./base.routes";
import guestRoutes from "./guest.routes";
import { COOKIE_TERMS_ACCEPTED, COOKIE_TOKEN } from "@/utils/constants";
import store from "@/store";

const { cookies } = useCookies();
export const routes = [...baseRoutes, ...guestRoutes];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const loginToken = cookies.get(COOKIE_TOKEN);
  const terms = cookies.get(COOKIE_TERMS_ACCEPTED);
  const authenticated = loginToken && loginToken.length > 0;
  document.title = authenticated ? "DB Cargo PWA App" : "Home";
  if (
    !authenticated &&
    to.name !== "login" &&
    to.name !== "reset-password-guest" &&
    to.name !== "code" &&
    to.name !== "reset-password-link"
  ) {
    next({ path: "/login" });
  } else if (to.path !== "/acceptTerms" && authenticated && !terms) {
    next({ path: "/acceptTerms" });
  } else if (to.path === "/login" && authenticated) {
    next({ path: "/" });
  } else {
    next();
  }
});

export default router;
